import {ajaxRequest} from "./base.js";

const address = {
    'token': true,
    'api': '/ordos-api',
    'bankapi': '/ordos-bank',
}
// 用户相关接口
const UserRelated = {
    // 企业手机号注册、登录
    loginBySms: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/loginBySms',
        type: 1,
        params: params,
    }),
    // 手机号登录、注册短信发送验证码
    loginVerifyCode: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/company/api/user/loginVerifyCode',
        type: 1,
        params: params,
    }),
    // 更新手机号、用户名，发送短信验证码
    updatePhoneSmsCode: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/company/updatePhoneSmsCode',
        type: 1,
        params: params,
        token: true
    }),
    // 一期用户，更新中文用户为手机号
    updateUserName: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/updateUserName',
        type: 1,
        params: params,
        token: true
    }),
}
//银行登录
const loginBank = {
    //获取验证码
    getCode: (params) => ajaxRequest({
        method: 'get',
        url: address.bankapi + '/session/verificationCode',
        type: 1,
        params: params,
        token: false
    }),
    //银行登录
    login: (params) => ajaxRequest({
        method: 'post',
        url: address.bankapi + '/session/login',
        type: 1,
        params: params,
        token: false
    }),
}
//数据源管理
const dataSource = {
    //门户-首页-获取固定文件路径
    postHomeStaticFileUrl: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/home/common/getHomeStaticFileUrl',
        type: 1,
        params: params,
        token: false
    }),
    //门户-首页-统计条数据
    postIndexStatistics: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/home/statistics',
        type: 1,
        params: params,
        token: false
    }),
    //门户-首页-找资金
    postFinanceProductFour: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/financeProduct/four',
        type: 1,
        params: params,
        token: false
    }),
    postIndexFinanceProduct: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/financeProduct/page/queryAll',
        type: 1,
        params: params,
        token: false
    }),
    //门户-首页-成果展示
    postIndexSuccDocking: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/succDocking/page/queryAll',
        type: 1,
        params: params,
        token: false
    }),
    //门户-首页-找项目
    postIndexCompanyProduct: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/companyProduct/page/queryAll',
        type: 1,
        params: params,
        token: false
    }),
    //门户-首页-政策动态
    postIndexNews: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/gov/page/queryAll',
        type: 1,
        params: params,
        token: false
    }),
    //门户-首页-政策动态-详情
    postIndexNewsDetail: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/gov/detail',
        type: 1,
        params: params,
        token: false
    }),
    // //门户-首页-合作伙伴
    // postIndexQueryFinInsPicUrl: (params) => ajaxRequest({
    //     method: 'post',
    //     url: address.api + '/homepage/api/finance/queryFinInsPicUrl',
    //     type: 1,
    //     params: params,
    //     token: false
    // }),//
    //门户-首页-合作伙伴
    postIndexQueryFinInsPicUrl: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/gov/partner',
        type: 1,
        params: params,
        token: false
    }),
    //门户-找资金-立即申请-详情
    postIndexFinanceDetail: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/financeProduct/page/queryDetail',
        type: 1,
        params: params,
        token: false
    }),
    //门户-找资金-立即申请-详情-填写融资需求
    postIndexAddProduct: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/companyProduct/addProduct',
        type: 1,
        params: params,
        token: address.token
    }),
    //门户-找资金-立即申请-详情-查询该企业是否存在该金融机构订单
    postIndexQueryEntIsInOrder: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/companyProduct/queryEntIsInOrder',
        type: 1,
        params: params,
        token: address.token
    }),
    //门户-找资金-立即申请-详情-获取企业当前融资需求订单
    postIndexGetCompanyOrder: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/companyProduct/getCompanyOrder',
        type: 1,
        params: params,
        token: address.token
    }),
    // 门户-找资金-立即申请-详情-验证企业产品和银行需求是否对等
    postIndexEntApplyFinanceCheck: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/home/companyProduct/entApplyFinanceCheck',
        type: 1,
        params: params,
        token: address.token
    }),
    //门户-找资金-机构类型-根据银行类别获取金融机构列表
    postIndexQueryInsByType: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/finance/queryInsByType',
        type: 1,
        params: params,
        token: false
    }),
    //门户-金融产品-详情-立即申请
    postIndexAddFinanceOtherOrder: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/finance/addFinanceOtherOrder',
        type: 1,
        params: params,
        token: address.token
    }),
    //门户-金融产品-详情-立即申请-第三步
    postIndexGetQueryDetail: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/companyProduct/page/queryDetail',
        type: 1,
        params: params,
        token: address.token
    }),
    //门户-找资金-详情-立即申请-查询企业融资产品是否展示在大厅
    postIndexQueryEntIsShow: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/companyProduct/page/queryEntIsShow',
        type: 1,
        params: params,
        token: address.token
    }),
    //门户-找资金-详情-立即申请-提交订单
    postIndexAddOrder: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/finance/api/demand/add',
        type: 1,
        params: params,
        token: address.token
    }),

    //门户-金融产品-详情-收藏状态
    postIndexEntCollectionStatus: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/companyProduct/queryEntCollection',
        type: 1,
        params: params,
        token: address.token
    }),
    //门户-金融产品-详情-浏览次数
    addBrowse: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/financeProduct/product/browse',
        type: 0,
        params: params,
        token: address.token
    }),

    //门户-金融产品-详情-收藏
    postIndexAddEntCollection: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/companyProduct/addEntCollection',
        type: 1,
        params: params,
        token: address.token
    }),
    //门户-找资金-获取金融机构列表
    postIndexQueryInsAll: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/finance/queryInsAll',
        type: 1,
        params: params,
        token: false
    }),
    //门户-找资金-详情-分支机构弹窗
    postIndexBranch: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/finance/queryInsAll1',
        type: 1,
        params: params,
        token: false
    }),
    //门户-获取字典项 区域-5001  担保方式-1001 期限-2001   额度-3001 保险产品类别-11001
    postIndexGetDictionaryList: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/home/common/getDictionaryList',
        type: 1,
        params: params,
        token: false
    }),
    //门户-获取行业字典项
    postIndexGetIndustryDicList: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/home/common/getIndustryDicList',
        type: 1,
        params: params,
        token: false
    }),
    //企业登录
    login: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/login/',
        type: 1,
        params: params,
        token: false
    }),
    // 获取登录验证码
    getVerificationCode: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/session/verificationCode',
        type: 1,
        params: params,
        token: false
    }),

    //企业注册1-发送验证码
    getRegSendCode: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/company/api/user/registerSendCode',
        type: 0,
        params: params,
        token: false
    }),
    //企业注册2-校验验证码（并保存注册信息）
    postRegister: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/registerVerifyCodeAndSumit',
        type: 1,
        params: params,
        token: false
    }),

    //忘记密码1-发送验证码
    getPhoneCode: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/company/api/user/forgetPwdSendCode',
        type: 0,
        params: params,
        token: false
    }),
    //忘记密码2-校验验证码
    postForgetPassword: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/forgetPwdVerifyCode',
        type: 1,
        params: params,
        token: false
    }),
    //忘记密码3-校验验证码（并修改密码）
    postUpdatePassword: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/forgetPwdVerifyCodeAndUpd',
        type: 1,
        params: params,
        token: false
    }),


    //修改手机号1-发送验证码
    getSendUpdatePhoneCode: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/company/api/user/updatePhoneSendCode',
        type: 1,
        params: params,
        token: address.token,
    }),
    //修改手机号2-校验当前手机验证码
    getSendUpdatePhoneCodeCheck: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/updatePhoneCheckCurPhoneCode',
        type: 1,
        params: params,
        token: address.token,
    }),
    //修改手机号3-校验验证码（并修改手机号）
    postUpdatePhone: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/updatePhoneCheckCodeAndUpdate',
        type: 1,
        params: params,
        token: address.token,
    }),

    //重置密码1-获取验证码
    getResetPasswordPhoneCode: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/company/api/user/resetPasswordSendCode',
        type: 0,
        params: params,
        token: address.token,
    }),

    //重置密码2-校验验证码（并修改新密码）
    postResetPassword: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/resetPasswordCheckCode',
        type: 1,
        params: params,
        token: address.token,
    }),

    //获取金融机构全部列表-(企业认证推荐银行)
    postGetFinanceUserList: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/getFinanceUserList',
        type: 1,
        params: params,
        token: address.token,
    }),
    //企业认证
    getAuthInfo: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/company/api/user/auth/info',
        type: 1,
        params: params,
        token: address.token,
    }),
    //企业认证0-发送验证码（法定代表人实名手机号）
    getSendLegalPhoneCode: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/company/api/user/auth/saveStep0',
        type: 1,
        params: params,
        token: address.token,
    }),
    //保存步骤1
    postSaveStepOne: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/auth/saveStep1',
        type: 1,
        params: params,
        token: address.token,
    }),
    //保存步骤2
    postSaveStepTwo: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/auth/saveStep2',
        type: 1,
        params: params,
        token: address.token,
    }),
    // 企业认证完四要素展示行业和区域
    queryAuthInfo: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/auth/queryEntIndustryCity',
        type: 1,
        params: params,
        token: address.token,
    }),
    //保存步骤3
    postSaveStepThree: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/auth/saveStep3',
        type: 1,
        params: params,
        token: address.token,
    }),
    //保存步骤4
    getSaveStepFour: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/auth/saveStep4',
        type: 1,
        params: params,
        token: address.token,
    }),
    //上传企业logo
    uploadFile: (params) => ajaxRequest({
        method: 'post',
        //url: address.api + '/api/file/localUpload/1',
        url: address.api + '/company/api/companyProduct/localUpload',
        type: 2,
        params: params,
        token: address.token,
    }),
    //获取企业信息
    postGetCompanyUserInfo: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/auth/getCompanyUserInfo',
        type: 2,
        params: params,
        token: address.token,
    }),
    //修改企业信息
    postUpdateAuthInfo: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/auth/updateAuthInfo',
        type: 1,
        params: params,
        token: address.token,
    }),
    //企业主页进行中的融资
    postFinanceApply: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/financeApply',
        type: 1,
        params: params,
        token: address.token,
    }),
    //企业主页 数据统计
    postStatistics: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/statistics',
        type: 2,
        params: params,
        token: address.token,
    }),
    //申请管理列表
    postCompanyProductPage: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/page/query',
        type: 1,
        params: params,
        token: address.token,
    }),
    //申请管理列表-修改融资需求（展示到大厅）
    postCompanyProductIsShow: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/updateFinanceProductIsShow',
        type: 1,
        params: params,
        token: address.token,
    }),
    //申请管理列表-筛选条件列表
    postGetConditionList: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/getConditionList',
        type: 1,
        params: params,
        token: address.token,
    }),
    // 获取金融机构全部列表-(企业基本户开户行)
    basicBank: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/company/api/companyProduct/basicBank',
        type: 1,
        params: params,
        token: address.token,
    }),
    //申请管理列表-详情-融资产品关联订单详情
    postOrderDetails: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/company/api/companyProduct/orderDetails',
        type: 1,
        params: params,
        token: address.token,
    }),
    //申请管理列表-详情-弹框-获取金融机构信息
    postGetinsInfo: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/company/api/companyProduct/getinsInfo',
        type: 1,
        params: params,
        token: address.token,
    }),
    //申请管理列表-详情-弹框-取消订单
    postCloseOrder: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/closeOrder',
        type: 1,
        params: params,
        token: address.token,
    }),
    //申请管理列表-详情-获取订单时间轴信息
    // postGetOrdeLog: (params) => ajaxRequest({
    //     method: 'post',
    //     url: address.api + '/company/api/companyProduct/getOrdeLog',
    //     type: 1,
    //     params: params,
    //     token: address.token,
    // }),
    //申请管理-删除
    postDeleteCompanyProduct: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/deleteByIds',
        type: 1,
        params: params,
        token: address.token,
    }),
    //申请管理-详情-提前终止
    postCompanyProductOrderIsComplete: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/orderIsComplete',
        type: 1,
        params: params,
        token: address.token,
    }),
    //修改融资需求状态服务 - 融资需求详情（提前终止）
    postCompanyProductUpdateState: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/updateState',
        type: 1,
        params: params,
        token: address.token,
    }),
    //发布融资需求
    postCompanyProductAdd: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/add',
        type: 1,
        params: params,
        token: address.token,
    }),
    //发布融资需求-暂存
    postDemandSave: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/finance/api/demand/save',
        type: 1,
        params: params,
        token: address.token,
    }),
    //发布融资需求-编辑-暂存
    postDemandUpdate: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/finance/api/demand/update',
        type: 1,
        params: params,
        token: address.token
    }),
    //智能匹配
    postProductScreen: (params) => ajaxRequest({
        method: 'post',
        // url: address.api + '/company/api/companyProduct/productScreen',
        url: address.api + '/finance/api/demand/smartList',
        type: 1,
        params: params,
        token: address.token,
    }),
    //订单状态
    postProductStatus: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/updateStatus',
        type: 1,
        params: params,
        token: address.token,
    }),
    //根据id查询融资产品 - 企业融资需求
    postProductSelectById: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/selectById',
        type: 1,
        params: params,
        token: address.token,
    }),
    //企业融资需求-编辑
    getDemandFinance: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/finance/api/demand/finance',
        type: 1,
        params: params,
        token: address.token,
    }),
    // 根据id查询企业融资状态（是否有未完成融资）- 企业融资需求
    postCompanyFinanceState: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/companyFinanceState',
        type: 2,
        params: params,
        token: address.token,
    }),
    //金融产品详情
    postFinanceProductDetails: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/financeProductDetails',
        type: 1,
        params: params,
        token: address.token,
    }),
    //金融产品 -提交申请
    postSubmitApplication: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/selectById',
        type: 1,
        params: params,
        token: address.token,
    }),
    //融资管理-发布融资申请-弹窗
    postGetByEntPid: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/selectByEntPid',
        type: 1,
        params: params,
        token: address.token,
    }),
    //金融产品 -
    postMakeOrder: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyProduct/makeOrder',
        type: 1,
        params: params,
        token: address.token,
    }),
    //合作伙伴-添加
    postAddCooperativePartner: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/cooperativePartner/add',
        type: 1,
        params: params,
        token: address.token,
    }),
    //合作伙伴-分页查询
    postQueryCooperativePartner: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/cooperativePartner/page/query',
        type: 1,
        params: params,
        token: address.token,
    }),
    //合作伙伴-删除
    postDeleteCooperativePartner: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/cooperativePartner/deleteByIds',
        type: 1,
        params: params,
        token: address.token,
    }),
    //添加或者修改平台外融资记录
    postSaveCompanyFinanceLog: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyFinanceLog/save',
        type: 1,
        params: params,
        token: address.token,
    }),
    //平台外融资记录-分页查询
    postQueryCompanyFinanceLog: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyFinanceLog/page/query',
        type: 1,
        params: params,
        token: address.token,
    }),
    //平台外融资记录-删除
    postDeleteCompanyFinanceLog: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyFinanceLog/deleteByIds',
        type: 1,
        params: params,
        token: address.token,
    }),
    //分页查询企业收藏表
    postCompanyCollection: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyCollection/page/query',
        type: 1,
        params: params,
        token: address.token,
    }),
    //添加收藏
    postAddCompanyCollection: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyCollection/add',
        type: 1,
        params: params,
        token: address.token,
    }),
    //取消收藏
    postUpdateCompanyCollection: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/companyCollection/update',
        type: 1,
        params: params,
        token: address.token,
    }),
    //尾部单日访问量、总访问量
    getViews: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/homepage/api/home/statistics/views',
        type: 1,
        params: params,
        token: false,
    }),
    //浏览记录每次访问自增
    postRecordViews: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/homepage/api/home/recordView',
        type: 1,
        params: params,
        token: false,
    }),
    //贴息
    postDiscountList: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/list',
        type: 1,
        params: params,
        token: true,
    }),
    //贴息 -区域列表
    postDiscountAreaList: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/areaList',
        type: 1,
        params: params,
        token: true,
    }),
    //贴息 -政策列表
    postDiscountPolicyList: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/policyList',
        type: 1,
        params: params,
        token: true,
    }),
    //上传贷款贴息申请表
    uploadDiscountApply: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/uploadDiscountApply',
        type: 1,
        params: params,
        token: true,
    }),
    //上传统一社会信用代码
    uploadCreditCode: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/uploadCreditCode',
        type: 1,
        params: params,
        token: true,
    }),
    //上传复工复产证明材料
    uploadResumeProve: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/uploadResumeProve',
        type: 1,
        params: params,
        token: true,
    }),
    //上传银行借款合同
    uploadBankLoan: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/uploadBankLoan',
        type: 1,
        params: params,
        token: true,
    }),
    //上传利息结算清单
    uploadInterestSettle: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/uploadInterestSettle',
        type: 1,
        params: params,
        token: true,
    }),
    //上传食品经营许可证
    uploadFoodBusiness: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/uploadFoodBusiness',
        type: 1,
        params: params,
        token: true,
    }),
    //上传贷款到账凭证
    uploadLoanCertificate: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/uploadLoanCertificate',
        type: 1,
        params: params,
        token: true,
    }),
    //新增贴息申请
    addDiscount: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/add',
        type: 1,
        params: params,
        token: true,
    }),
    //修改贴息申请
    updateDiscount: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/discount/update',
        type: 1,
        params: params,
        token: true,
    }),
    //贴息详情
    discountDetail: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/discount/detail',
        type: 1,
        params: params,
        token: true,
    }),
    //获取贴息联系人信息
    getContactPerson: (params) => ajaxRequest({
        method: 'get',
        url: address.api + '/discount/getContactPerson',
        type: 1,
        params: params,
        token: true,
    }),
}

// 上传
const uploadFile = {
    // 上传营业执照
    uploadBusinessLicense: (params) => ajaxRequest({
        method: 'post',
        url: address.api + '/company/api/user/auth/uploadBusinessLicense',
        type: 1,
        params: params,
        token: true
    }),
}
export {
    dataSource,
    loginBank, //银行登录
    uploadFile,
    UserRelated
}
